import { AuthenticationService } from '../../../../pages/auth/_core/services/authentication.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { SessionKeys } from '../../../../pages/auth/_core/services/token-storage.service';
import { AuthService } from '../../../../pages/auth/_core/services/auth.service';
import { JwtService } from '../../../../../shared/services/jwt.service';
import { JwtUserModel } from '../../../../../shared/models/jwt-user.model';
import { StorageService } from '../../../../../shared/services/storage.service';
import { StorageKeyEnum } from '../../../../../shared/enums/storage-key.enum';

@Component({
	selector: 'm-user-profile',
	templateUrl: './user-profile.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserProfileComponent implements OnInit {
	@HostBinding('class')
	// tslint:disable-next-line:max-line-length
	classes = 'm-nav__item m-topbar__user-profile m-topbar__user-profile--img m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light';

	@HostBinding('attr.m-dropdown-toggle') attrDropdownToggle = 'click';

	@Input() avatar: string = './assets/app/media/img/users/user4.jpg';
	@Input() avatarBg: SafeStyle = '';

	@ViewChild('mProfileDropdown') mProfileDropdown: ElementRef;

	jwtUser: JwtUserModel = null;
	nombre: string = null;
	constructor (
		private router: Router,
		private authService: AuthService,
		private sanitizer: DomSanitizer,
		private jwtService: JwtService,
		private storageService: StorageService,
		private cd: ChangeDetectorRef
	) {}

	ngOnInit (): void {
		this.jwtUser = this.jwtService.getUser();
		this.nombre = this.storageService.get(StorageKeyEnum.Nombre)
		if (!this.avatarBg) {
			this.avatarBg = this.sanitizer.bypassSecurityTrustStyle('url(./assets/app/media/img/misc/user_profile_bg.jpg)');
		}
		this.cd.detectChanges();this.cd.markForCheck();

	}

	public logout () {
		this.authService.logoff()
		this.authService.redirectToLogin();
	}
}
